<template>
  <FormKit :name="name" :value="value" type="hidden" />
</template>

<script setup lang="ts">
import { fieldHiddenDefaultValue, fieldName } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const name = fieldName(props.field, props.parentField)
const value = fieldHiddenDefaultValue(props.field)
</script>
